var _ = require('underscore'),
    PageNote = require('../../pgNote'),
    fvChannel = require('glRadio').channel('FV'),
    GroupCollection = require('../../../../../user/groups/groupCollection');


module.exports = PageNote.extend({

    SUPPORTS_FIND_AND_REDACT: 0,

    STORES_COLOR: 1, // flag if drawable note type stores color

    SUPPORTS_COLOR_PICKER: 0, // whether the note type supports a color picker in DV

    /**
     * Store an array of shape models that can be set on parse.
     * Currently only used by full page redaction, but may later apply to other note types;
     */
    constructor: function( attrs, options ) {

        this.shapes = [];

        this.creationUserGroups = null; // keep around in case ever wanted ( eg to provide more specificity on where color's coming from )
        this.groupOfDerivedCreationUserGroupColor = null; // use to get the color, also more info like the name

        // Set on parse -- on cancel will revert to this in case set otherwise; could be different attributes (eg text)
        this.originalShapeAttrs = null;

        return PageNote.prototype.constructor.apply( this, arguments );

    },


    parse: function( attrs, options ) {

        var isNew = !attrs.sequence;

        attrs = PageNote.prototype.parse.apply( this, arguments );

        this.setOriginalShapeAttrsOnParse( attrs );

        /**
         * For all that store color ( everyone except GRAPHIC stamps -- set creationUserGroups & groupOfDerivedCreationUserGroupColor )
         * - potential area for perf improvement, it saved note cusr if current user, use current user's creationGroups
         */
        if ( this.STORES_COLOR ) {


            if ( !isNew ) {

                // Check for backwards compatibility ( eg fixture without the attribute )
                if ( attrs.creationUserGroups ) {
                    // Yeah more Backbone overhead but keeps this more organized with fn to get off the groups collection
                    this.creationUserGroups = new GroupCollection( attrs.creationUserGroups );
                }


            } else {

                // New - unsaved:
                var currentUserGroups = fvChannel.request('user').groups;

                // Set the 'cached' creation user groups
                this.creationUserGroups = currentUserGroups;

                // For node server, put creationUserGroupColor on the attributes so they
                // are returned on save ( the real server will always recalculate and return ).
                // Could move to save, but seems reasonable here to keep with other logic for now.
                if ( fvChannel.request('settings').isRunningNode ) {

                    attrs.creationUserGroups = currentUserGroups.toJSON(); // no need to cache ( just DEV and not much perf hit )
                }

            }

            // Check: in place for old pageNote fixtures lacking attrs.creationUserGroups
            if ( this.creationUserGroups ) {

                this.groupOfDerivedCreationUserGroupColor =
                    this.creationUserGroups.getGroupOfDerivedUserColor();

            }

        }

        return attrs;

    },

    getGroupOfDerivedCreationUserGroupColor: function() {

        return this.groupOfDerivedCreationUserGroupColor;

    },

    getCreationUserGroupColor: function() {

        if ( !this.getGroupOfDerivedCreationUserGroupColor() )
            return null;

        return this.groupOfDerivedCreationUserGroupColor.getColor();

    },

    /**
     * testing -- on re-render of canvas the shapes attribute can be updated
     * will need to change on diff note types for diff attributes used
     * shapes is what is used to create the shape models -- maybe on parse get the attributes required and make the shapes out of that ?
     */
    resetOnCancelChanges: function() {

        PageNote.prototype.resetOnCancelChanges.apply( this, arguments );

        this.resetShapeAttrsOnCancelChanges();

    },

    /* Overwride if not using the shapes object to read in */
    /* Typically attrs is 'shapes' */
    setOriginalShapeAttrsOnParse: function( response ) {

        this.originalShapeAttrs = response.shapes;

    },

    /* Can override, like, eg for 'text' */
    resetShapeAttrsOnCancelChanges: function() {

        this.set( 'shapes', this.originalShapeAttrs );

    },

    draw: true,
    autoDisplayApplies: true, // all but redaction, graphicStamp, textStamp
    ViewConstructor: require('../../../../views/note/drawableNote'),

    getDefaultShapeColor: function() {
        return this.defaultShapeColor;
    },

    /*
    * Override if a factory: eg redaction -- to return a different constructor.
    * Otherwise: returns the constructor on the prototype
    * */
    getShapeModel: function() {
        return this.ShapeModel;
    },

    getDefaultShapeSubType: function() {
        return this.defaultSubType;
    },

    /**
     * Update the note model attributes from the shapes on the canvas so we can
     * use the attributes to getNewShapeModels.
     * Called on canvas re-render for the active note, since for now, shape models are
     * not peristed on the note and will be lost in the re-render call.
     * shapeAttributesOfNote: what would be used to persist the notes a save call --
     * Note: this would be enough for saved shapes that had been modified, but not
     * any 'newlyDrawn' shapes -- these are then added to the shapes array in the re-render function,
     * since they wouldn't yet exist on the note model.
     * see the canvas shape code -- an interim refactor
     */
    updateAttributesToCreateShapeModelsOnCanvasReRender: function( shapeAttributesOfNote ) {

        this.set( shapeAttributesOfNote );

    },

    /*
     * Return whether the shapes of 'drawable notes' should be hidden or shown.
     * Note: page text notes also have a noteStatus but it is meaningless to Doc Viewer --
     * it determines whether FDD client will pop open the window for these notes on load.
     * */
    applyAutoDisplayToShapes: function () {
        return ( (this.autoDisplayApplies && this.get('noteStatus') !== 'V') );
    },

    supportsColorPicker: function() {

        return this.SUPPORTS_COLOR_PICKER;

    },

    supportsFindAndRedact: function() {

        return this.SUPPORTS_FIND_AND_REDACT;

    },

    /**
     * Must disallow picking the 'actual color' if there are any overrides, which now include
     * the current 'derived' consult color and group cusr creation color.
     * Return null if should not disable or an error message for a tooltip explanation to disable it.
     */
    disableColorPickerDueToColorRules: function( ) {

        if ( !this.supportsColorPicker )
            return;

        var disableReasons = [];

        var consultGroupColor = this.getCurrentConsultColorForShapes();
        if ( consultGroupColor )
            disableReasons.push( 'One consult group with a color is assigned to the note.' );


        var noteCreationUserGroupColor = this.getCreationUserGroupColor();
        if ( noteCreationUserGroupColor )
            disableReasons.push( 'Note creation user belongs to one group with a color assigned.' );


        if ( disableReasons.length === 0 )
            return null;

        return disableReasons.join('\n');


    }


});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/page/noteTypes/drawable/base.js
 ** module id = 151
 ** module chunks = 0
 **/